export default "__VITE_ASSET__Cdec5soT__"